<template>
      <div>
      <slide-over-panel-wide
          v-model:show="$data._show"
          @update:show="updateShow($data._show)"
      >
      <template #title>
        <div class="text-center text-2xl">{{ reportHistory.report_type_pretty }}</div>
      </template>

        <template #title-content>
          <div v-if="isApproval" class="w-3/4 flex justify-center">
            <review-confirmation-modal
                :confirmationEnabled="true"
                :reportHistory="reportHistory"
                :selectedReviewType="selectedReviewType"
                @close="close"
            ></review-confirmation-modal>
          </div>
        </template>

        <template #content>
          <div      v-if="reportHasData"
                    class="h-full">
                    <iframe v-if="reportHistory.cloud_file_path !== null"
                        :src="reportHistory.cloud_file_path"
                        class="w-full h-full"
                    >
                    </iframe>
                    <div v-else>
                      <div class="text-center text-2xl">No Report Available at this time</div>
                    </div>
          </div>
          <div  v-else-if="! reportGenerated">
                <div class="text-center text-2xl">Report is being generated.</div>
                <div    class="pb-2">
                    Please check back later.
                </div>
          </div>


          <div    v-else>
              <div>
                <div class="text-center text-2xl">No Report was generated.</div>
                <div    class="pb-2">
                    A report was not generated because there was no data for the points within the date range.
                </div>
                <div>
                    <span   class="">Start: {{reportHistory.report_start_time_pretty}}</span>
                    <span   class="px-1">-</span>
                    <span   class="">End: {{reportHistory.report_end_time_pretty}}</span>
                </div>
              </div>
          </div>
        </template>
      </slide-over-panel-wide>
      </div>
</template>


<script>
import axios from "axios";
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from "@/mixins/IconNamesMixin";
import {UrlParamsMixin} from "@/mixins/UrlParamsMixin";
import ButtonBluePrimary from "@/components/elements/buttons/ButtonBluePrimary";
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import ReviewConfirmationModal from "@/components/ReportHistory/reviewConfirmationModal";
import SlideOverPanelWide from '@/components/elements/SlideOverPanelWide';
export default {
  name: "ReportPreview",
  mixins: [SonicuCoreMixin, iconNamesMixin, UrlParamsMixin],
  components: {
    ReviewConfirmationModal,
    ButtonBluePrimary, Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot, SlideOverPanelWide},
  compatConfig: {
    MODE: 3, // opt-in to Vue 3 behavior for this component only
  },
  props: {
    show: Boolean,
    reportHistory: Object,
    selectedReviewType: String,
    isApproval: Boolean
  },
    data() {
      return {
        _show: this.show,
        processing: false,
        notesText: '',
      }
      },
  mounted() {
  },
  methods: {
    updateShow(show) {
      this.$data._show = show
      this.$emit('update:show', this.$data._show)
    },
    close() {
      this.$emit('update:isOpen', false);
      // Adding the close event on modal close.
      this.$emit('close');
    },
    clickCancel(){
      this.$emit('action', false);
      this.close();
    },
    getReport(){
      axios.get(this.company.buildCompanyApiInternalRoute(`report-history`),
          {
            params: params,
          }
      ).then(response => {
        let data = response.data;
        //  if (data.meta.requestNumber !== `${this.requestNumber}`) {
        //    return
        //  }
        this.ajaxUpdateTableData(data); // This sends the data to the mixin for AjaxTable
        this.data = !_.isNil(data.data) ? data.data : [];
      }).catch(error => {
        console.log(error)
      }).then(() => {
        this.processing = false;
        this.ajaxTable.loading = false;
      })
    },
  },
  watch: {
    show() {
      this.$data._show = this.show;
    },
  },
  computed: {
      reportHasData() {
        return this.reportHistory.cloud_file_path !== null;
      },
      reportGenerated() {
          return this.reportHistory.job_completed_at !== null;
      }
  },
}
</script>

<style scoped>
</style>